import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref } from "vue"
import _imports_0 from '@/assets/img/NKT MakeSense_Logo_for screen.png'


const _hoisted_1 = {
  class: "offcanvas offcanvas-end",
  tabindex: "-1",
  id: "offcanvasNavbar",
  "aria-labelledby": "offcanvasNavbarLabel"
}
const _hoisted_2 = { class: "offcanvas-body ms-canvasbody" }
const _hoisted_3 = {
  key: 0,
  class: "sign-in-container d-flex flex-column align-items-center justify-content-between"
}
const _hoisted_4 = { class: "d-flex flex-column align-items-center justify-content-between" }
const _hoisted_5 = {
  key: 0,
  class: "text-center mt-what-is-nkt-text"
}
const _hoisted_6 = {
  key: 1,
  class: "d-flex flex-column align-items-center"
}
const _hoisted_7 = {
  key: 0,
  class: "text-center mt-what-is-nkt-text"
}

import { onMounted, ref, watch } from 'vue'
import { requiredInject } from '@/utilities/requiredInject'
import { MSAL } from '@/plugins/msal/msal'
import { useUserStore } from '@/stores/UserStore'
import { UserClient } from '@/server/MakeSenseApp-backend'
import MsButton from '@/components/general/buttons/MsButton.vue'
import { Offcanvas } from 'bootstrap'
import { ButtonStyles, ButtonSize } from '@/utilities/enums'


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginBar',
  props: {
  isLoggedIn: {
    type: Boolean
  }
},
  setup(__props) {

const userName = ref<string>()
const userStore = useUserStore()

const isSignedIn = ref(true)
const showWhatIsNKT = ref(false)
const showDoNotHaveAccess = ref(false)

const msal = requiredInject<MSAL>('MSAL')
const userClient = requiredInject<UserClient>('UserClient')

const props = __props

onMounted(() => {
  watch(
    () => userStore.refreshDataCounter,
    () => {
      if (msal.isAuthenticated()) {
        userClient.currentUser().then((user) => {
          userStore.setCurrentUser(user)
          userName.value = user.name

          if (userStore.hasNoRoles) {
            showCanvas()
            showDoNotHaveAccess.value = true
          }
        })

        isSignedIn.value = true
      } else {
        isSignedIn.value = false
        showCanvas()
      }
    },
    { immediate: true }
  )
})

function showCanvas() {
  var element = document.getElementById('offcanvasNavbar')

  if (element) {
    const offcanvas = new Offcanvas(element, {
      backdrop: props.isLoggedIn == false ? 'static' : true,
      keyboard: props.isLoggedIn == false ? false : true
    })
    offcanvas.show()
  }
}

async function logout() {
  await msal.logout()
}

async function login() {
  await msal.login()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (isSignedIn.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h3", null, "Welcome, " + _toDisplayString(userName.value), 1),
              (showDoNotHaveAccess.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[1] || (_cache[1] = [
                    _createElementVNode("div", null, [
                      _createTextVNode(" You have successfully signed in, but you currently do not have access to NKT MakeSense. "),
                      _createElementVNode("br"),
                      _createTextVNode(" If you believe this is an error, please contact us for assistance. ")
                    ], -1)
                  ])))
                : _createCommentVNode("", true)
            ]),
            _createVNode(MsButton, { onClick: logout }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode("Sign Out")
              ])),
              _: 1
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _cache[6] || (_cache[6] = _createElementVNode("img", {
              src: _imports_0,
              class: "logo-login"
            }, null, -1)),
            _cache[7] || (_cache[7] = _createElementVNode("h3", null, "Sign in", -1)),
            _createVNode(MsButton, {
              class: "mt-signin-button",
              "button-type": _unref(ButtonStyles).PrimaryOrange,
              "button-size": _unref(ButtonSize).Standard,
              onClick: login
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode("Sign in with NKT ID")
              ])),
              _: 1
            }, 8, ["button-type", "button-size"]),
            _createVNode(MsButton, {
              class: "mt-what-is-nkt-button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showWhatIsNKT.value = !showWhatIsNKT.value))
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode("What is NKT ID?")
              ])),
              _: 1
            }),
            (showWhatIsNKT.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[5] || (_cache[5] = [
                  _createElementVNode("div", null, " For your convenience, we use a Single Sign-On (SSO) system across all our platforms. This means you only need one account to access all our services. ", -1),
                  _createElementVNode("br", null, null, -1),
                  _createElementVNode("div", null, " When you click \"Sign in\" you'll be redirected to our secure company-wide login page to complete the process. ", -1),
                  _createElementVNode("br", null, null, -1),
                  _createElementVNode("div", null, "If you already have an account with us, simply use your existing credentials.", -1)
                ])))
              : _createCommentVNode("", true)
          ]))
    ])
  ]))
}
}

})